import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { PageHeader, DataTable, Pill } from "../components/Table";
import { PaperPlaneRight } from "@phosphor-icons/react";

const STATUS_COLOR = { QUEUED: "#8E8E93", SENT: "#5AC8FA", DELIVERED: "#5AC8FA", ACKNOWLEDGED: "#FF9500", VERIFIED: "#34C759", FAILED: "#FF3B30" };

export default function Commands() {
  const [params] = useSearchParams();
  const [imei, setImei] = useState(params.get("imei") || "");
  const [devices, setDevices] = useState([]);
  const [cmds, setCmds] = useState([]);
  const [cmdType, setCmdType] = useState("GET_CONFIG");
  const [ip, setIp] = useState("103.20.104.79");
  const [port, setPort] = useState("7172");

  const load = () => api.get("/commands").then((r) => setCmds(r.data.commands));
  useEffect(() => {
    api.get("/devices").then((r) => { setDevices(r.data.devices); if (!imei && r.data.devices[0]) setImei(r.data.devices[0].imei); });
    load();
  }, []);

  const send = async () => {
    if (!imei) return toast.error("Select a device");
    const params = cmdType === "SET_SERVER" ? { primaryIp: ip, primaryPort: parseInt(port) } : {};
    await api.post("/commands", { imei, command: cmdType, parameters: params });
    toast.success("Command queued");
    load();
  };

  const ack = async (id) => { const r = await api.post(`/commands/${id}/simulate-ack`); toast.info(`Device → ${r.data.status}`); load(); };

  const columns = [
    { key: "command_id", header: "Command ID", render: (r) => <span className="font-mono text-xs">{r.command_id}</span> },
    { key: "imei", header: "IMEI", render: (r) => <span className="font-mono text-xs">{r.imei}</span> },
    { key: "command_type", header: "Type", render: (r) => <span className="font-semibold">{r.command_type}</span> },
    { key: "status", header: "Status", render: (r) => <Pill color={STATUS_COLOR[r.status]}>{r.status}</Pill> },
    { key: "created_by", header: "By" },
    { key: "step", header: "", render: (r) => r.status !== "VERIFIED" && r.status !== "FAILED"
      ? <button data-testid={`ack-cmd-${r.id}`} onClick={() => ack(r.id)} className="text-xs font-semibold px-2 py-1 border border-border rounded-sm hover:border-primary">Advance</button>
      : null },
  ];

  return (
    <div className="p-5 space-y-4">
      <PageHeader title="OTA Command Center" subtitle="Success = device acknowledgement, not just sent" />
      <div className="bg-card border border-border rounded-sm p-4 grid grid-cols-1 md:grid-cols-5 gap-3 items-end">
        <div>
          <label className="label-caps">Device (IMEI)</label>
          <select data-testid="cmd-imei" value={imei} onChange={(e) => setImei(e.target.value)} className="mt-1 w-full bg-background border border-border rounded-sm px-2 py-2 text-sm">
            {devices.map((d) => <option key={d.imei} value={d.imei}>{d.imei}</option>)}
          </select>
        </div>
        <div>
          <label className="label-caps">Command</label>
          <select data-testid="cmd-type" value={cmdType} onChange={(e) => setCmdType(e.target.value)} className="mt-1 w-full bg-background border border-border rounded-sm px-2 py-2 text-sm">
            {["GET_CONFIG", "SET_SERVER", "SET_INTERVAL", "SET_APN", "RESET"].map((c) => <option key={c}>{c}</option>)}
          </select>
        </div>
        {cmdType === "SET_SERVER" && <>
          <div><label className="label-caps">Primary IP</label><input value={ip} onChange={(e) => setIp(e.target.value)} className="mt-1 w-full bg-background border border-border rounded-sm px-2 py-2 text-sm font-mono" /></div>
          <div><label className="label-caps">Port</label><input value={port} onChange={(e) => setPort(e.target.value)} className="mt-1 w-full bg-background border border-border rounded-sm px-2 py-2 text-sm font-mono" /></div>
        </>}
        <button data-testid="cmd-send" onClick={send} className="flex items-center justify-center gap-1.5 bg-primary text-white font-semibold rounded-sm py-2 text-sm">
          <PaperPlaneRight size={15} weight="fill" /> Send Command
        </button>
      </div>
      <DataTable testid="commands-table" columns={columns} rows={cmds} empty="No commands sent yet" />
    </div>
  );
}
